import { Controller } from "@hotwired/stimulus"
import { Sortable } from 'sortablejs'
import { patch } from '@rails/request.js'

// Connects to data-controller="field-transformations-sort"
//
// Drag-reorders the compact transform rows and persists the new order immediately
// to the reorder endpoint (FieldTransformation has no acts_as_list — order is a
// sequence_priority assigned from the submitted id order).
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: '.sortable-handle',
      animation: 150,
      onEnd: () => this.#persist()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  #persist() {
    const ids = Array.from(this.element.querySelectorAll('[data-transform-id]'))
      .map(el => el.dataset.transformId)
    patch(this.urlValue, { body: { ids } })
  }
}
